
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/check-order",
      function () {
        return require("private-next-pages/check-order.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/check-order"])
      });
    }
  